module.exports = __webpack_public_path__ + "static/nelson_outline-bf17a293ae7f1f820d6e791b14beffb0.png";